export default {
  SELECT_SOCIETY_TOKEN: '@society/SELECT_SOCIETY_TOKEN',
  SELECT_PROJECT_TOKEN: '@society/SELECT_PROJECT_TOKEN',
};
